export const drawTieTeams = ["draw", "tie"];
